import { render } from "./Twitch.vue?vue&type=template&id=1bd7d397"
import script from "./Twitch.vue?vue&type=script&lang=js"
export * from "./Twitch.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__